import React, { ReactNode, useEffect, useState } from 'react'
import { Close } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import {
  SnackbarProvider,
  useSnackbar,
  SnackbarKey,
  VariantType,
  SnackbarProviderProps
} from 'notistack'
import useStyles from './styles'

interface DismissActionProps {
  id: SnackbarKey
}

const DismissAction: React.FC<DismissActionProps> = ({ id }) => {
  const [isSuccess, setIsSucces] = useState<boolean>(false)
  const theme = useTheme()

  useEffect(() => {
    const snackbarElement = document.querySelector('.SnackbarContent-root')
    if (snackbarElement?.className?.toLocaleLowerCase().includes('success')) {
      setIsSucces(true)
    }
  }, [])

  const { closeSnackbar } = useSnackbar()

  return (
    <>
      <IconButton
        size="small"
        onClick={() => closeSnackbar(id)}
        data-testid="IconButton-9936fd20-229d-4444-98af-4265760cfa2f"
      >
        <Close
          fontSize="small"
          sx={{
            color: isSuccess ? '#FFFFFF' : theme.palette.error.main
          }}
        />
      </IconButton>
    </>
  )
}

interface NotistackProviderProps {
  children: ReactNode
}

// Custom interface extending SnackbarProviderProps
interface CustomClasses {
  containerRoot: string
  contentRoot: string
  message: string
  action: string
  variantInfo: string
  variantSuccess: string
  variantWarning: string
  variantError: string
  [key: string]: string
}

function NotistackProvider({ children }: NotistackProviderProps) {
  const classes = useStyles()

  return (
    <SnackbarProvider
      dense
      maxSnack={5}
      preventDuplicate
      autoHideDuration={2000}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      classes={classes as unknown as Record<string, string>}
      action={id => <DismissAction id={id} />}
    >
      {children}
    </SnackbarProvider>
  )
}

export default NotistackProvider
